import React from 'react';

import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@mui/material';
import useClasses from '../../helpers/useClasses';

const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  list: {
    paddingLeft: theme.spacing(3)
  }
});

const PrivacyPolicy  = (props) => {
  const classes = useClasses(styles);

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Card>
          <CardContent>
            <Typography
              variant="h4"
            >
              PRIVACY POLICY
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              Last Modified: 02-25-2026
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              This Privacy Policy (this "Policy") is a binding contract between you ("Customer," "User," "Member," "you," or "your", as applicable) and Datamerch LLC (“Company”, "we," "us," or "our"). This Policy governs the collection, storage, and use of information collected via datamerch.com (the "Site") and the information services, data, and content provided by Company (collectively, the "Services"). This Policy is incorporated by reference into the Company Terms of Use Agreement. If there is a conflict between the provisions of this Policy and the Terms of Use Agreement, the Terms of Use Agreement shall control.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              PLEASE READ THIS POLICY CAREFULLY. BY ACCESSING OR USING THE SITE OR THE SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THIS POLICY IN ITS ENTIRETY. IF YOU DO NOT ACCEPT THESE TERMS, YOU MAY NOT ACCESS OR USE THE SERVICES.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="h4"
            >
              I. DEFINITIONS AND ELIGIBILITY
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              1. <b>Merchant Defined</b>. For purposes of this Policy and the Services, a "Merchant" is defined strictly as a commercial entity, which may include a corporation, limited liability company (LLC), limited liability partnership (LLP), partnership, or sole-proprietorship. In accordance with our business model, Company views sole-proprietors, single-shareholder corporations, single-member partnerships, and single-member companies as commercial entities and never as individual consumers.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              2. <b>Service Description</b>. Company operates a members-only online information-sharing database where funding organizations in the alternative business financing industry share data on unsatisfactory Merchant accounts to cross-reference and underwrite to avoid potential losses.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              3. <b>Eligibility</b>. The Services are intended for use by funding organizations only.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="h4"
            >
              II. INFORMATION COLLECTION
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              1. <b>Categories of Information</b>. Company collects the following categories of information: (a) Information from Users to share across the database regarding unsatisfactory Merchant accounts. (b) Personal information about Merchants (limited to sole proprietors) required to verify the business entity. (c) Business information of Merchants necessary for business verification. (d) Optional information shared among Users to define risk associated with Merchant accounts.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              2. <b>Information Collected from Users</b>. (a) <b>Technical Data</b>. We collect information about your computer and your visits to the Site, including your IP address, geographical location, browser type, referral source, length of visit, and page views. (b) <b>Cookies and Tracking Technologies</b>. We utilize cookies, pixels, and web beacons to identify web browsers, track Member "click stream" activity, and personalize your experience. These technologies allow us to collect log data and device identifiers, such as domain names and country of origin, to assist in protecting account security and gathering statistical data. (c) <b>Contact Information</b>. We gather names and email addresses of individuals who contact us with inquiries to assist with their respective needs. (d) <b>Analytics Providers</b>. Company may use third-party analytics providers to monitor and analyze the use of our Services to improve Site administration and marketing strategies. You may manage or opt-out of certain tracking through your browser settings; however, disabling these technologies may limit your ability to use certain features or functionality of the Services.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              3. <b>Information Collected from Members regarding Merchants</b>. Information collected includes, but is not limited to: email addresses, full names (sole proprietors only), telephone numbers, Federal Employer Identification Numbers (FEIN), business legal names, "Doing Business As" (DBA) names, business addresses, and additional notes or optional information entered by Members.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="h4"
            >
              III. OWNERSHIP AND USE OF INFORMATION
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              1. <b>Ownership</b>. All Member, User, Merchant, and Customer information submitted, posted, transmitted, or entered on the Site ("Customer Data") is jointly owned by Company and the Customer that submitted such data. A Customer’s ownership interest applies only to the Customer Data that Customer specifically provided; Customers have no ownership rights in any data, submissions, content, or other materials submitted to the Services by other Customers or other users (including any Authorized Users of such other Customers), even if such materials are accessible through the Services. Company reserves broad rights to host and process all such data to operate the Services and is under no obligation to return or provide copies of information stored in the Company database, except as required by law or expressly agreed, and no obligation to provide copies of other Members’ submissions.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              2. <b>Permitted Use</b>. We share information collected from Members across the Site so that other Members may search for such information and make underwriting judgments. Aggregated technical information is used for Site administration and evaluating marketing/SEO strategies.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              3. <b>FCRA Compliance</b>. Company does not constitute a "consumer reporting agency" under the Fair Credit Reporting Act (FCRA). Because Company only accepts and distributes data on commercial entities, Users are prohibited from providing information on individual persons or consumers.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              4. <b>International Transfer</b>. By providing Company with any information through the Site, you consent to the transmission of such information over state, federal, and international borders as necessary for processing.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="h4"
            >
              IV. SECURITY AND PASSWORDS
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              1. <b>Security Policy and Confidentiality Disclaimer</b>. Company disclaims any obligation to maintain the confidentiality of information provided through the Services. While Company currently utilizes reasonable efforts to maintain confidentiality through physical, electronic, and operational policies, including network firewalls, encryption, and hardened operating systems, these practices do not constitute a guarantee of absolute security. For further information regarding the parties' respective obligations, please refer to Section 6 of the Terms of Use Agreement.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              2. <b>Account Responsibility</b>. You are responsible for maintaining the confidentiality of your account and password. Company requires admin accounts per Member to assign unique sub-account logins for employees.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              3. <b>Termination of Access</b>. Members must disable sub-accounts immediately if an employee with access is terminated.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="h4"
            >
              V. AGE RESTRICTIONS
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              The Services and the Site are intended for use by adults only. Only persons aged 18 or older may use the Services or provide data. Company does not knowingly collect information from persons under the age of eighteen (18). You certify that you are at least 18 years of age and will not knowingly enter personally identifiable information about any person under the age of 18. If you are under 18, you are prohibited from using the Services.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="h4"
            >
              VI. OPT-OUT AND MODIFICATIONS
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              1. <b>Opt-Out Procedure</b>. To opt-out of marketing communications, email us at support@datamerch.com. Note that you cannot opt out of transactional emails related to your account or active disputes.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              2. <b>Modifications</b>. This Policy is subject to change. Your continued use of the Services after modifications constitutes your acceptance of the most current version of the Policy.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="h4"
            >
              VII. CONTACT INFORMATION
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              Datamerch LLC 23110 State Rd 54 #247, Lutz, FL 33549 Email: support@datamerch.com Telephone: [PHONE NUMBER]
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="h4"
            >
              VIII. COMMUNICATION SERVICES AND PUBLIC INFORMATION
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              The Site may contain bulletin board services, chat areas, forums, and other message facilities ("Communication Services") designed to enable you to communicate with others. Any information, including personally identifying information, that you disclose in these Communication Services may be viewed by the public, if a feature is publicly accessible or you choose to make content public, or may be viewed by other Users and is not subject to the confidentiality protections of this Policy. You are solely responsible for the content of your Submissions and the consequences of posting them. Company does not control or endorse the content found in any Communication Service and specifically disclaims any liability regarding such services and any actions resulting from your participation.
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="h4"
            >
              IX. THIRD-PARTY PRODUCTS AND LINKED SITES
            </Typography>
            <Typography
              sx={{
                marginTop: '15px'
              }}
              variant="subtitle2"
            >
              The Services may permit access to Third-Party Products and Linked Sites. Company is not responsible for the privacy practices, data transmission provisions, or content of any third-party websites. By using any functionality originating from the Site domain, you acknowledge and consent that Company may share your information and data with third parties with whom Company has a contractual relationship to provide the requested service on your behalf. Your interactions with these third parties are governed by their respective privacy policies, and Company expressly disclaims any liability related to such third-party provisions.
            </Typography>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default PrivacyPolicy;
